import { cn } from "@roman/shared/utils";
import type React from "react";

interface EditProfileButtonProps {
  children: React.ReactNode;
  className?: string;
}

export const EditProfileButton: React.FC<EditProfileButtonProps> = ({ children, className }) => {
  return (
    <button
      className={cn(
        "hover:cursor-pointer bg-primary w-full text-white py-2.5 px-5 rounded-md font-bold text-lg",
        className,
      )}
      type="submit"
    >
      {children}
    </button>
  );
};
